<script lang="ts">
    import { _ } from 'svelte-i18n';
  
    import Modal from './Bootstrap/Modal.svelte';
    import GroupCommunityPicker from './GroupCommunityPicker.svelte';
    
    export let group_communities;
    export let onChange = ()=>{}
    export let joinSession;
  
    let modal: Modal;
    let picker: GroupCommunityPicker
    let waiting;
    let joined_club;
    let has_joined_club;
    let community_items;
  </script>
  
  <Modal bind:this={modal} id="communityModal">
    <h4 class="w500" slot="title">
      {$_("sessions.browser.group_training_communities")}
    </h4>
  
    <GroupCommunityPicker bind:waiting={waiting} bind:this={picker} bind:joined_club={joined_club} bind:has_joined_club={has_joined_club} bind:community_items={community_items} onChange={onChange} onClose={()=>{modal.close()}} group_communities={group_communities}/>

    <div class="footer" slot="footer">
      {#if community_items}
        {#if has_joined_club}
        <button type="button" disabled={waiting} class="btn btn-default" on:click={() => picker.doLeave()}>
          <div class={waiting ? "fas fa-circle-notch fa-spin" : ""}/>
          Leave
        </button>
        <spacer/>
        {/if}
        <button type="button" disabled={waiting || community_items.find(c=>c.joined) == null} class:waiting class="btn btn-default" on:click={()=>picker.submit()}>
          <div class={waiting ? "fas fa-circle-notch fa-spin" : ""}/>
          {$_("sessions.group_picker.join")}
        </button>
      {:else}
        <button type="button" disabled={true} class="btn btn-default">
          {$_("sessions.group_picker.join")}
        </button>
      {/if}
    </div>
  </Modal>
  
  <style lang="scss">
    @import './style/xert.scss';
    h4.w500 {
      font-size: 20px;
    }
    h1.w400 {
      margin-bottom: 24px;
    }
    .medium {
      @include medium-text;
      margin-bottom: 24px;
    }
    .center {
      text-align: center;
    }
    grid {
      display: grid;
      grid-gap: 16px;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      padding: 16px;
  
      &.communities {
        height:360px;
      }
      &.times {
        height:180px;
      }
  
      &.waiting {
        opacity: 50%;
      }
  
      > button {
        @include medium-text;
        color: #2F7076;
  
        background: rgba(47, 112, 118, 0.2);
        border: unset;
        border-radius: 4px !important; // !important to override bootstrap theme. 
  
        &.joined {
          border: 2px solid #2F7076;
        }
      }
    }
    .footer {
      display: flex;
      justify-content: end;
    }
    .footer > button {
      @include medium-text;
      height: 40px;
      padding: 10px;
      min-width: 104px;
      color: white;
      border: unset !important;
      background: #2F7076;
      border-radius: 4px !important;
    }
  
  </style>
  